<div class="spinner-border text-red" role="status">
    <span class="sr-only">Loading...</span>
</div>